module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if (locals.noTracker) { 
    ; __append(" <span class=\"text-muted\">(No Tracker Associated)</span> ")
    ;  } else { 
    ; __append(" <div class=\"hidden-sm hidden-md hidden-lg\"> ")
    ;  if (locals.trackingCode && locals.publicUrl) { 
    ; __append(" <a href=\"")
    ; __append(escapeFn( locals.publicUrl ))
    ; __append("\" target=\"_blank\">")
    ; __append(escapeFn( locals.trackingCodeTruncated ))
    ; __append("</a> ")
    ;  } else if (locals.trackingCode) { 
    ; __append(" ")
    ; __append(escapeFn( locals.trackingCode ))
    ; __append(" ")
    ;  } 
    ; __append(" </div> <div class=\"hidden-xs\"> ")
    ;  if (locals.trackingCode && locals.publicUrl) { 
    ; __append(" <a href=\"")
    ; __append(escapeFn( locals.publicUrl ))
    ; __append("\" target=\"_blank\">")
    ; __append(escapeFn( locals.trackingCode ))
    ; __append("</a> ")
    ;  } else if (locals.trackingCode) { 
    ; __append(" ")
    ; __append(escapeFn( locals.trackingCode ))
    ; __append(" ")
    ;  } 
    ; __append(" </div> ")
    ;  }
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/list/item/headings/tracking_code/template.ejs
// module id = 789
// module chunks = 1